module.exports = __webpack_public_path__ + "img/PB_Logo.00ca70c.png";